import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {FormsModule} from "@angular/forms";
import { runtimeEventManager, switchClass } from '@wm/core';

const DEFAULT_CLS = 'app-slider slider';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-slider',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

const RANGE_LABEL_POSITION: {[key: string]: string} = {
  top: 'range-label-top',
  side: 'range-label-side',
  bottom: 'range-label-bottom',
};

@Component({
  selector: '[wmSlider]',
  template: `<div *ngIf="!isPrismWeb; else prismSlider">
  <span class="app-slider-value pull-left" [attr.aria-valuemin]="minvalue">{{minvalue}}</span>
  <span class="app-slider-value pull-right" [attr.aria-valuemax]="maxvalue">{{maxvalue}}</span>
  <input class="  range-input" aria-orientation="horizontal"
         focus-target
         type="range" [title]="datavalue"
         [attr.min]="minvalue"
         [attr.max]="maxvalue"
         [attr.step]="step"
         [(ngModel)]="datavalue"
         [disabled]="disabled"
         [attr.accesskey]="shortcutkey"
         [attr.aria-label]="hint || 'Slider'"
         [attr.aria-valuemin]="minvalue"
         [attr.aria-valuemax]="maxvalue"
         [attr.aria-valuenow]="datavalue"
         [tabindex]="tabindex"
         [attr.name]="name"
         [tabindex]="tabindex"/>
    </div>
    <ng-template #prismSlider>
      <div class="slider-container">
         <button class="btn-icon" type="button" name="decrementButton" *ngIf="showicons">
            <i aria-hidden="true" [ngClass]="starticon"></i></button>
        <div class="slider-control">
          <span class="app-slider-value pull-left" [attr.aria-valuemin]="minvalue">{{minvalue}}</span>
          <span class="app-slider-value pull-right" [attr.aria-valuemax]="maxvalue">{{maxvalue}}</span>
          <input class="range-input pointer-none" aria-orientation="horizontal"
              focus-target
              type="range" [title]="datavalue"
              [attr.min]="minvalue"
              [attr.max]="maxvalue"
              [attr.step]="step"
              [(ngModel)]="datavalue"
              (ngModelChange)="handleChange($event)"
              [disabled]="disabled"
              [attr.accesskey]="shortcutkey"
              [attr.aria-label]="hint || 'Slider'"
              [attr.aria-valuemin]="minvalue"
              [attr.aria-valuemax]="maxvalue"
              [attr.aria-valuenow]="datavalue"
              [tabindex]="tabindex"
              [attr.name]="name"
              [tabindex]="tabindex"/>
            <p class="active-slider"></p>
        </div>
    <button class="btn-icon" type="button" name="incrementButton" *ngIf="showicons">
       <i aria-hidden="true" [ngClass]="endicon"></i>
    </button>
</div>
    </ng-template>
  <div *ngIf="readonly || disabled" aria-readonly="true" class="readonly-wrapper"></div>
  `,
  providers: [
    provideAsWidgetRef(SliderComponent)
  ],
  exportAs: 'wmSlider',
  standalone: true,
  imports: [ CommonModule,FormsModule ],
  styles: []
})
export class SliderComponent extends StylableComponent {
  static initializeProps = register('wm-slider');
  public minvalue: number = 0;
  public maxvalue: number = 100;
  public disabled: boolean;
  public step: number;
  public shortcutkey: string;
  public tabindex: any;
  public name: string;
  public readonly: boolean;
  public hint: string;
  public datavalue:any
  public showicons: boolean;
  public starticon: string;
  public endicon:string;
  public isPrismWeb: boolean

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
      const projectService = runtimeEventManager.getService('projectService');
      this.isPrismWeb = projectService.isPrismWeb();
  }

  override ngAfterViewInit() {
    if (this.datavalue) {
      setTimeout(() => { this.updateSliderValue(); });
    }
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    switch (key) {
      case 'datavalue':
      case 'maxvalue':
      case 'minvalue':
        this.updateSliderValue()
        break;
      case 'rangelabelposition':
        switchClass(this.nativeElement, RANGE_LABEL_POSITION[nv], RANGE_LABEL_POSITION[ov]);
        break;
      default:
        super.onPropertyChange(key, nv, ov);
    }
  }

  handleChange(event: any) {
        this.updateSliderValue();
  }

   updateSliderValue() {
    const sliderValue = 100 - ((((this.datavalue || 50) - this.minvalue) / (this.maxvalue - this.minvalue)) * 100);
    const slider = this.nativeElement.querySelector('.slider-control') as HTMLElement;
    if (slider) {
      const safePercent = Math.min(100, Math.max(0, sliderValue));
      slider.style.setProperty('--end', `${safePercent}%`);
    }
  }

}

